// extracted by mini-css-extract-plugin
export var checkboxInputRow = "s_rS";
export var checkboxInputColumn = "s_rT";
export var inputOptionRow = "s_qq";
export var inputOptionColumn = "s_qr";